var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 274,
    viewBox: "0 0 180 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5434 173.98C62.2018 183.891 58.858 193.665 60.5122 203.301C62.9933 217.755 75.0023 238.693 92.7549 234.339C110.508 229.986 139.177 212.273 116.986 173.98",
    stroke: "#0BB3F0",
    strokeWidth: 13.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.611 199.722C101.688 196.618 101.628 197.445 101.628 194.396",
    stroke: "#0BB3F0",
    strokeWidth: 13.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7656 199.722C84.7656 197.947 84.7656 196.171 84.7656 194.396",
    stroke: "#0BB3F0",
    strokeWidth: 13.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7539 213.924C92.7539 215.646 92.7539 219.226 92.7539 220.171",
    stroke: "#0BB3F0",
    strokeWidth: 13.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0096 191.729C42.0204 200.942 42.5573 207.33 45.6203 210.895C50.2149 216.242 24.8496 264.765 24.8496 266.676C24.8496 268.588 58.5896 252.072 61.2841 249.53C63.9786 246.989 81.8489 252.829 95.5117 251.942C109.175 251.054 121.986 245.19 125.295 245.19C128.603 245.19 153.289 262.535 154.383 263.527C155.477 264.519 143.331 209.66 139.749 206.688C136.166 203.716 144.051 192.617 141.74 189.07",
    stroke: "#0BB3F0",
    strokeWidth: 13.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1271 103.752C64.0499 108.704 51.3256 103.675 43.6935 98.3051C40.8122 96.2778 25.3112 113.965 12.7027 98.3051C-7.36951 73.3747 21.1116 35.3345 52.3019 35.3345C58.7913 35.3345 60.602 9.2426 89.0315 6.27395C121.627 2.87028 123.031 32.3072 127.484 32.3072C130.671 32.3072 146.687 18.0078 162.451 33.1267C195.733 65.047 146.153 79.2864 146.421 80.1389C148.072 85.3635 163.043 81.8763 165.36 90.4332C171.384 112.672 124.593 105.815 115.43 98.9101",
    stroke: "#FACA15",
    strokeWidth: 11.585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0151 116.245C87.8376 128.287 83.9959 156.801 83 158.787",
    stroke: "#FACA15",
    strokeWidth: 11.585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.238 113.965C102.588 129.384 106.749 145.194 106.749 160.306",
    stroke: "#FACA15",
    strokeWidth: 11.585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.954 121.388C198.756 143.125 -18.1991 148.356 74.4335 122.948",
    stroke: "#FACA15",
    strokeWidth: 11.585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.42082bc6a39d3043fe1424d11cb2a474.svg";
export { ForwardRef as ReactComponent };